module.exports = __webpack_public_path__ + "static/illustration_speed-a2c2e32dd957b93e7710b934e8a4bd3b.svg";